export const MAX_PALETTES_COUNT = 10;
export const SPACE_KEY_CODE = 32;
export const MIN_PALETTES_COUNT = 2;
export const LANDSCAPE = 'landscape-primary';
export const MIDDLE_RANGE = 7.5;
export const COLOR_RANGE = 39;
